import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;
  currentUrl = '';

  constructor(private router: Router, public authService: AuthService) {}
  
  ngOnInit(): void {
    this.currentUrl = this.router.url;
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  get shouldShowNavbar(): boolean {
    return this.authService.canAccessProtectedRoutes() && !this.isPublicRoute(this.currentUrl);
  }

  private isPublicRoute(url: string): boolean {
    return url === '' || url === '/' || url === '/login';
  }

  logOut() {
    this.authService.clearSession();
    this.router.navigate(['/login']);
  }
  
}
